export default __webpack_public_path__ + "static/media/LouverLevel1.72a51a38.svg";